import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

import { useSelector, useDispatch } from "react-redux";

import { onHideErrorModal } from "../../store/slice/modalSlice";

import { useCmsHook } from "../../helpers/cmsHook";

function ErrorModal() {
  const { cmsInstance } = useCmsHook();
  const dispatch = useDispatch();
  const { errorMessage } = useSelector((state) => state.modal);
  console.log(errorMessage);

  useEffect(() => {
    // Added timer for hiding the error modal
    if (errorMessage) {
      const timer = setTimeout(() => {
        dispatch(onHideErrorModal());
      }, 3000);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorMessage]);

  const checkContentFrom = () => {
    const message = errorMessage.split(".");
    const messageFrom = message.includes("cmsContent");
    return messageFrom;
  };

  return (
    <div>
      <Modal
        className="my-modal"
        onHide={() => dispatch(onHideErrorModal())}
        show={errorMessage}
      >
        <div className="error-modal">
          <div className="d-flex flex-row justify-content-end">
            <Button
              className="error-modal-button"
              onClick={() => dispatch(onHideErrorModal())}
            >
              ×
            </Button>
          </div>
          {checkContentFrom() ? (
            <>
              {cmsInstance &&
                cmsInstance.showRichText(errorMessage, "error-modal-message")}
            </>
          ) : (
            <p className="error-modal-message mb-4 mx-3">{errorMessage}</p>
          )}
        </div>
      </Modal>
    </div>
  );
}

export default ErrorModal;
